type Props = {
  value: number | undefined;
  className?: string;
};

export default function RankingBar({ value, className }: Props) {
  return (
    <div
      className={`h-2 w-full rounded-md bg-gray-100 dark:bg-gray-800 ${className}`}
    >
      <div
        className={`h-full rounded-md 
        ${
          !value
            ? ''
            : value >= 80
            ? 'bg-lime-600'
            : value >= 50
            ? 'bg-lime-700'
            : value < 50
            ? 'bg-lime-800'
            : 'text-xl'
        } 
        `}
        style={{ width: (value ?? 0) + '%' }}
      ></div>
    </div>
  );
}
